var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg404(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 355.649,
    height: 142.236,
    viewBox: "0 0 355.649 142.236",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.46,
    y1: 0.062,
    x2: 0.665,
    y2: 0.814,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#18eaca",
    stopOpacity: 0.141
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#18eaca"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_108943",
    "data-name": "Path 108943",
    d: "M536.188,264.22l8.323,3.23,1.9-4.71s5.9.509,5.832,0a33.751,33.751,0,0,0-2.074-5.54c-.293-.118-9.509-2.739-9.68-2.673s-4.1,1.888-4.122,2.306,0,5.394,0,5.394Z",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_404",
    "data-name": 404,
    transform: "translate(-335.693 -198.425)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_62312",
    "data-name": "Group 62312"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_62307",
    "data-name": "Group 62307",
    transform: "translate(41.11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_108837",
    "data-name": "Path 108837",
    d: "M149.837,242.406c-.088-6.648-.359-13.306-.264-19.955l20.67,11.951c-.109,6.653.158,13.317.237,19.97Z",
    transform: "translate(206.969 68.724)",
    fill: "none",
    stroke: "#1228f3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108838",
    "data-name": "Path 108838",
    d: "M98.687,282.5c7.706-2.15,14.955-6.664,21.211-11.546l20.642,11.966c-6.254,4.889-13.5,9.427-21.211,11.584Z",
    transform: "translate(236.907 40.177)",
    fill: "none",
    stroke: "#1228f3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108839",
    "data-name": "Path 108839",
    d: "M98.811,252.545l-.124,19.12,20.643,12,.149-19.135Z",
    transform: "translate(236.907 51.011)",
    fill: "#c2c7fb",
    stroke: "#1228f3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108840",
    "data-name": "Path 108840",
    d: "M4.871,275.118c13.215-6.794,26.177-14.608,38.722-22.573l20.669,11.989c-12.545,7.989-25.506,15.825-38.723,22.643Z",
    transform: "translate(292.125 51.011)",
    fill: "none",
    stroke: "#1228f3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108844",
    "data-name": "Path 108844",
    d: "M151.3,77.761q.1-32.4.2-64.807l20.785,11.883q-.146,32.429-.282,64.858Z",
    transform: "translate(205.938 192.028)",
    fill: "none",
    stroke: "#1228f3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108845",
    "data-name": "Path 108845",
    d: "M162.917,155.3c-3.971,1.861-7.788,4.1-11.613,6.242L172,173.477c3.825-2.148,7.641-4.394,11.612-6.262Z",
    transform: "translate(205.938 108.246)",
    fill: "#c2c7fb",
    stroke: "#1228f3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108848",
    "data-name": "Path 108848",
    d: "M52.958,159.777c5.55-16.29,12.739-32.287,19.791-47.977l20.746,11.942c-7.064,15.714-14.275,31.729-19.84,48.041Z",
    transform: "translate(263.822 133.85)",
    fill: "none",
    stroke: "#1228f3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108849",
    "data-name": "Path 108849",
    d: "M72.159,201.076l-19.2,11.246,20.7,12.007,19.2-11.281Z",
    transform: "translate(263.822 81.305)",
    fill: "none",
    stroke: "#1228f3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108850",
    "data-name": "Path 108850",
    d: "M101.061,111.577l.452-.156,20.746,11.942-.452.156Z",
    transform: "translate(235.51 134.073)",
    fill: "none",
    stroke: "#1228f3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108851",
    "data-name": "Path 108851",
    d: "M100.669,111.421l-1.042,36.886,20.7,11.972,1.091-36.916Z",
    transform: "translate(236.354 134.073)",
    fill: "#c2c7fb",
    stroke: "#1228f3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108852",
    "data-name": "Path 108852",
    d: "M124.38,106.959a34.146,34.146,0,0,0-.253-6.527c-3.971,1.868-7.787,4.114-11.612,6.262q.141-32.429.282-64.858c-8.241,1.208-16.72,6.375-23.943,10.3C80.447,68.6,73.542,85.974,66.388,103.006c-3.528,8.4-7.016,16.817-10.382,25.283-2.555,6.426-6.181,13-5.734,20.031a97.229,97.229,0,0,0,1.967,14.84c13.217-6.818,26.177-14.655,38.723-22.643l-.149,19.135c7.707-2.164,14.954-6.692,21.21-11.584-.079-6.653-.341-13.317-.237-19.97,4.029-2.346,8.765-4.463,12.295-7.512C124.351,116.063,124.353,111.491,124.38,106.959Z",
    transform: "translate(265.425 175.028)",
    fill: "#fff",
    stroke: "#1228f3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108854",
    "data-name": "Path 108854",
    d: "M123.556,140.447l-1.091,36.916-19.2,11.281c5.565-16.312,12.776-32.327,19.84-48.041Z",
    transform: "translate(234.213 116.989)",
    fill: "#c2c7fb",
    stroke: "#1228f3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108841",
    "data-name": "Path 108841",
    d: "M.394,275.839a100.963,100.963,0,0,0,1.842,12.99L22.9,300.887a101.355,101.355,0,0,1-1.823-13Z",
    transform: "translate(294.76 37.301)",
    fill: "#c2c7fb",
    stroke: "#1228f3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108842",
    "data-name": "Path 108842",
    d: "M38.577,37.9C25.114,64.277,14.022,92.453,3.4,120.079c-2.143,5.576-3.7,9.78-3.162,15.714l20.687,12.051c-1.016-11.429,6-23.028,10.257-33.4q8.887-21.656,18.306-43.091c3.173-7.22,6.288-14.5,9.875-21.528Z",
    transform: "translate(294.913 177.347)",
    fill: "#c2c7fb",
    stroke: "#1228f3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108843",
    "data-name": "Path 108843",
    d: "M117.519,12.954C109.28,14.148,100.8,19.3,93.571,23.216L114.36,35.139c7.211-3.921,15.709-9.117,23.943-10.3Z",
    transform: "translate(239.918 192.028)",
    fill: "#fff",
    stroke: "#1228f3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_62308",
    "data-name": "Group 62308",
    transform: "translate(19.172)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_108867",
    "data-name": "Path 108867",
    d: "M128.789,71.268c-1.768,12.756-19.559,23.787-29.362,29.343q-3.232,1.819-6.547,3.482A121.161,121.161,0,0,1,76,111.02v-.015c-16.824,5.382-34.91,6.586-51.635-.247C16.027,107.35,5.321,101.63,1.623,92.823c-3.331-7.931,1.7-15.488,7.255-20.9.334-.324.676-.644,1.016-.965C5.579,74.894,1.379,79.811.623,85.688c-1.02,7.925-.193,16.5.036,24.637v.046c0-.015,0-.031,0-.046a13.4,13.4,0,0,0,.055,3.254c0-.466-.007-.935-.015-1.405A14.244,14.244,0,0,0,1.77,117.2a23.071,23.071,0,0,0,6.307,8.116c7.362,6.569,18.634,11.048,26.162,12.769a73.1,73.1,0,0,0,31.006.009q.676-.133,1.349-.278l.02,0q2.113-.453,4.208-1.007a121.175,121.175,0,0,0,27.107-11.174l1.458-.815c10.866-6.166,26.946-15.383,29.22-28.964a15.055,15.055,0,0,0,.182-3.4Z",
    transform: "translate(431.413 200.403)",
    fill: "#fff",
    stroke: "#1228f3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108877",
    "data-name": "Path 108877",
    d: "M188.063,102.066c-1.85,1.086-3.471,1.978-4.595,2.619,1.292-.735,3.064-1.687,5.029-2.813h-.107l-.327.193",
    transform: "translate(324.311 182.346)",
    fill: "#ffec00",
    stroke: "#1228f3",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108878",
    "data-name": "Path 108878",
    d: "M188.063,102.066c-1.85,1.086-3.471,1.978-4.595,2.619,1.292-.735,3.064-1.687,5.029-2.813h-.107Z",
    transform: "translate(324.311 182.346)",
    fill: "none",
    stroke: "#1228f3",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108879",
    "data-name": "Path 108879",
    d: "M169.571,47.793c-.2.058-.4.126-.6.187q.644-.2,1.305-.384c-.247.066-.486.132-.71.2",
    transform: "translate(332.776 214.052)",
    fill: "#ffec00",
    stroke: "#1228f3",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108880",
    "data-name": "Path 108880",
    d: "M169.571,47.793c-.2.058-.4.126-.6.187q.644-.2,1.305-.384C170.034,47.662,169.8,47.728,169.571,47.793Z",
    transform: "translate(332.776 214.052)",
    fill: "none",
    stroke: "#1228f3",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108881",
    "data-name": "Path 108881",
    d: "M158.779,48.961c-2.12.667-4.2,1.444-6.254,2.308.471-.193.943-.386,1.408-.572,1.46-.582,3.1-1.182,4.845-1.737",
    transform: "translate(342.387 213.255)",
    fill: "#ffec00",
    stroke: "#1228f3",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108882",
    "data-name": "Path 108882",
    d: "M158.779,48.961c-2.12.667-4.2,1.444-6.254,2.308.471-.193.943-.386,1.408-.572C155.394,50.115,157.033,49.515,158.779,48.961Z",
    transform: "translate(342.387 213.255)",
    fill: "none",
    stroke: "#1228f3",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108883",
    "data-name": "Path 108883",
    d: "M167.564,48.7c.2-.062.391-.124.588-.184-.2.061-.393.122-.588.184",
    transform: "translate(333.602 213.514)",
    fill: "#ffec00",
    stroke: "#1228f3",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108884",
    "data-name": "Path 108884",
    d: "M167.564,48.7c.2-.062.391-.124.588-.184C167.954,48.579,167.759,48.64,167.564,48.7Z",
    transform: "translate(333.602 213.514)",
    fill: "none",
    stroke: "#1228f3",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108885",
    "data-name": "Path 108885",
    d: "M129.391,25.938l-.057-.373a17.2,17.2,0,0,0-3.393-7.514C118.54,8.2,106.159,3.025,93.456,1.139A79.793,79.793,0,0,0,72.784.814,91.969,91.969,0,0,0,58.8,3.674C42.251,8.383,25.321,16.939,12.215,28.163c-.57.488-1.145.994-1.719,1.517-.34.321-.682.64-1.016.965-5.558,5.409-10.586,12.967-7.255,20.9,3.7,8.807,14.4,14.526,22.745,17.935,16.724,6.833,34.81,5.629,51.635.247l.056-.018a119.141,119.141,0,0,0,16.821-6.895q3.318-1.657,6.547-3.483c9.8-5.555,27.594-16.586,29.362-29.342a14.578,14.578,0,0,0,0-4.049M76.969,45.347l-.351.2C68.042,50.495,57.725,56.1,47.456,55.838a25.958,25.958,0,0,1-2.759-.211c-8.984-1.2-16.508-7.684-8.756-15.6C43.33,32.481,54.278,26.861,64.1,22.84c2.05-.864,4.134-1.641,6.253-2.308.2-.062.39-.124.588-.184s.4-.128.6-.187c.224-.065.462-.131.71-.2,3.986-1.062,10.928-2.129,16.508-1.027A13.8,13.8,0,0,1,95.479,22.9c6.2,6.747-5.582,14.9-13.588,19.633H82c-1.965,1.125-3.737,2.077-5.029,2.812",
    transform: "translate(430.695 241.684)",
    fill: "#fff",
    stroke: "#1228f3",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108887",
    "data-name": "Path 108887",
    d: "M139.809,48.438a13.8,13.8,0,0,0-6.723-3.965c-5.58-1.1-12.522-.035-16.508,1.027q-.66.187-1.3.384c-.2.059-.392.123-.588.184-1.746.554-3.385,1.154-4.845,1.737-.466.185-.937.378-1.408.571C98.608,52.4,87.66,58.016,80.271,65.562c-7.752,7.917-.228,14.405,8.756,15.6a25.745,25.745,0,0,0,2.759.211c9.154-5.657,19.895-10.258,23.722-11.406a47.087,47.087,0,0,1,10.385-1.7l.327-.193c8.006-4.731,19.789-12.886,13.588-19.633",
    transform: "translate(386.48 216.149)",
    fill: "#c2c7fb",
    stroke: "#1228f3",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108888",
    "data-name": "Path 108888",
    d: "M139.809,48.438a13.8,13.8,0,0,0-6.723-3.965c-5.58-1.1-12.522-.035-16.508,1.027q-.66.187-1.3.384c-.2.059-.392.123-.588.184-1.746.554-3.385,1.154-4.845,1.737-.466.185-.937.378-1.408.571C98.608,52.4,87.66,58.016,80.271,65.562c-7.752,7.917-.228,14.405,8.756,15.6a25.745,25.745,0,0,0,2.759.211c9.154-5.657,19.895-10.258,23.722-11.406a47.087,47.087,0,0,1,10.385-1.7l.327-.193C134.227,63.34,146.01,55.185,139.809,48.438Z",
    transform: "translate(386.48 216.149)",
    fill: "none",
    stroke: "#1228f3",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_62306",
    "data-name": "Group 62306",
    transform: "translate(-9.828)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_108776",
    "data-name": "Path 108776",
    d: "M925.234,271.144c-.081-6.8-.347-13.614-.24-20.416l-20.749,12.065c-.1,6.807.177,13.625.267,20.432Z",
    transform: "translate(-237.211 52.081)",
    fill: "none",
    stroke: "#1228f3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108777",
    "data-name": "Path 108777",
    d: "M873.675,268.313a70.749,70.749,0,0,0,21.382,13.181l-20.722,12.081a71.019,71.019,0,0,1-21.383-13.22Z",
    transform: "translate(-207.034 41.73)",
    fill: "none",
    stroke: "#1228f3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108778",
    "data-name": "Path 108778",
    d: "M873.825,221.985l-.15,19.061-20.723,12.042.124-19.075Z",
    transform: "translate(-207.034 68.998)",
    fill: "none",
    stroke: "#1228f3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108783",
    "data-name": "Path 108783",
    d: "M926.775,107.237q.143-32.54.285-65.081l-20.865,12q-.1,32.565-.2,65.131Z",
    transform: "translate(-238.255 174.841)",
    fill: "none",
    stroke: "#1228f3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108784",
    "data-name": "Path 108784",
    d: "M938.541,207.6c-3.791-2.608-7.813-4.909-11.766-7.261L906,212.389c3.953,2.36,7.977,4.665,11.766,7.283Z",
    transform: "translate(-238.255 81.738)",
    fill: "none",
    stroke: "#1228f3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108787",
    "data-name": "Path 108787",
    d: "M926.417,200.537c3.967,2.358,7.993,4.671,11.805,7.274l-20.776,12.072c-3.812-2.611-7.839-4.931-11.806-7.3Z",
    transform: "translate(-238.045 81.622)",
    fill: "none",
    stroke: "#1228f3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108793",
    "data-name": "Path 108793",
    d: "M874.032,240.868l.151-19.111-20.748,12.028-.125,19.125Z",
    transform: "translate(-207.244 69.132)",
    fill: "none",
    stroke: "#1228f3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108794",
    "data-name": "Path 108794",
    d: "M895.121,281.183a67.157,67.157,0,0,1-21.089-12.975L853.309,280.25a67.583,67.583,0,0,0,21.09,13.013Z",
    transform: "translate(-207.244 41.792)",
    fill: "none",
    stroke: "#1228f3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108795",
    "data-name": "Path 108795",
    d: "M924.692,250.2l-.06.04c-.15,6.77.129,13.573.234,20.342l-20.722,12.081c-.112-6.776-.4-13.582-.261-20.358C910.8,258.236,917.755,254.239,924.692,250.2Z",
    transform: "translate(-236.989 52.388)",
    fill: "none",
    stroke: "#1228f3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108804",
    "data-name": "Path 108804",
    d: "M924.815,270.571c-.1-6.785-.484-13.652-.222-20.433L903.844,262.2c-.253,6.787.139,13.658.249,20.449Z",
    transform: "translate(-236.938 52.428)",
    fill: "#c2c7fb",
    stroke: "#1228f3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108805",
    "data-name": "Path 108805",
    d: "M874.032,268.208a70.842,70.842,0,0,0,21.089,13L874.4,293.287a70.791,70.791,0,0,1-21.09-13.037Z",
    transform: "translate(-207.244 41.792)",
    fill: "#fff",
    stroke: "#1228f3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108806",
    "data-name": "Path 108806",
    d: "M874.182,221.758l-.151,19.111-20.723,12.042.125-19.125Z",
    transform: "translate(-207.244 69.132)",
    fill: "none",
    stroke: "#1228f3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108820",
    "data-name": "Path 108820",
    d: "M879.146,96.262c-.017,4.618-.132,9.236-.279,13.851l-.038.1c-4.294-1.934-8.35-4.553-12.426-6.908-.264,6.78-.907,6.011-.806,12.8-7.667-2.948-13.918.075-20.061-5.362l.15-19.111c-13.144-6.807-26.265-14.253-38.719-22.245-1.213-6.934-2.323-14.383-2.025-21.434,4.543-8.921,11.8-16.9,18.1-24.593,6.329-7.73,12.716-16.275,20.445-22.691,8.217,4.963,17.1,10.277,23.917,17.1l-.258,65.146c3.958,2.353,7.975,4.661,11.778,7.258A41.321,41.321,0,0,1,879.146,96.262Z",
    transform: "translate(-178.871 199.262)",
    fill: "#fff",
    stroke: "#1228f3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108835",
    "data-name": "Path 108835",
    d: "M829.315,111.4l-2.946,36.976-21.9-10.074c5.147-9.067,14.845-21.278,21.9-28.924Z",
    transform: "translate(-180.063 133.652)",
    fill: "#c2c7fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108830",
    "data-name": "Path 108830",
    d: "M847.147,155.364,828.96,143.89l-24.407,13.482,22.3,12.185Z",
    transform: "translate(-180.063 114.655)",
    fill: "#fff",
    stroke: "#1228f3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108889",
    "data-name": "Path 108889",
    d: "M74.434,89.628C70.7,87.007,66.7,84.737,62.784,82.4q.135-32.408.27-64.815A85.931,85.931,0,0,0,47.3,5.344C44.371,3.485,41.416,1.718,38.555,0A69.988,69.988,0,0,0,31.4,7.189Q28.342,10.55,25.381,14q-.819.978-1.635,1.943-2.726,3.214-5.408,6.473Q15.5,25.9,12.727,29.427q-.793,1.007-1.6,2.023-2.788,3.606-5.468,7.289A63.779,63.779,0,0,0,.031,47.413a52.358,52.358,0,0,0,.245,6.625A154.057,154.057,0,0,0,2.15,69.394c12.34,8.023,25.429,15.274,38.425,22.183l-.137,18.868A71.333,71.333,0,0,0,62.3,123.966c-.032-6.752-.294-13.5-.251-20.255l.015-.009c3.754,2.172,8.3,5.23,12.711,6.734-.148-.048-.145.083,0,.129v-.129c.385-4.422.259-9.071.285-13.515a32.829,32.829,0,0,0-.621-7.294M41.7,71.506,21.077,59.75a26,26,0,0,1,1.673-2.822l.105-.156q.149-.219.3-.437L23.393,56c.087-.123.174-.246.262-.369l.115-.161c.312-.433.628-.862.943-1.289,2.9-3.942,5.9-7.894,9.023-11.732,1.511-1.733,3.01-3.438,4.437-5.119,1.087-1.281,2.171-2.566,3.324-3.787L42.8,34.592Z",
    transform: "translate(604.99 211.339)",
    fill: "#c2c7fb",
    stroke: "#1228f3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108810",
    "data-name": "Path 108810",
    d: "M892.967,18.321c-6.815-6.826-15.9-12.694-24.122-17.658L847.61,13.088c8.22,4.981,17.573,10.44,24.391,17.279Z",
    transform: "translate(-204.105 198.262)",
    fill: "#fff",
    stroke: "#1228f3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108890",
    "data-name": "Path 108890",
    d: "M5008.579-942.732l.3,20.565,20.8-12.058-.379-20.391Z",
    transform: "translate(-4329 1244)",
    fill: "#fff",
    stroke: "#1228f3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108891",
    "data-name": "Path 108891",
    d: "M4996.933-950.533l20.555-11.239",
    transform: "translate(-4329 1244)",
    fill: "none",
    stroke: "#1228f3",
    strokeLinecap: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_108906",
    "data-name": "Path 108906",
    d: "M4859.5-959.135a53.116,53.116,0,0,0-18.94,5.279c-9.577,4.8-13.229,6.82-13.229,6.82a25.905,25.905,0,0,0,9.856-1.237C4842.929-950.029,4859.5-959.135,4859.5-959.135Z",
    transform: "translate(-4329 1244)",
    fill: "#3c4ef5",
    opacity: 0.653
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_62309",
    "data-name": "Group 62309",
    transform: "translate(4 4)",
    opacity: 0.508
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_108895",
    "data-name": "Path 108895",
    d: "M2.237,9.52c-.108-.246-.625-.361-1.153-.258S.214,9.649.323,9.9s.625.361,1.153.257.869-.387.761-.633",
    transform: "translate(542.97 247.76)",
    fill: "#1228f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108897",
    "data-name": "Path 108897",
    d: "M13.967,5.389c-.108-.246-.625-.361-1.153-.258s-.869.387-.761.633.625.361,1.153.257.869-.387.761-.633",
    transform: "translate(526.372 250.177)",
    fill: "#1228f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108902",
    "data-name": "Path 108902",
    d: "M7.771,7.258S8,4.579,6.1,5.091C3.778,5.718,2.9,8.429,2.9,8.429s-.474,1.693-.169,10v3.408",
    transform: "translate(536.485 250.216)",
    fill: "none",
    stroke: "#3c4ef5",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108903",
    "data-name": "Path 108903",
    d: "M19.521,3.178S19.729.486,17.838,1c-2.326.627-3.207,3.338-3.207,3.338s-.474,1.693-.169,10l.094,9.225",
    transform: "translate(519.868 252.611)",
    fill: "none",
    stroke: "#3c4ef5",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1652",
    "data-name": "Line 1652",
    x2: 4.773,
    y2: 1.802,
    transform: "translate(534.24 259.157)",
    fill: "none",
    stroke: "#3c4ef5",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1653",
    "data-name": "Line 1653",
    x1: 4.866,
    y1: 1.728,
    transform: "translate(534.23 262.124)",
    fill: "none",
    stroke: "#3c4ef5",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1654",
    "data-name": "Line 1654",
    x2: 4.891,
    y2: 1.724,
    transform: "translate(534.281 265.021)",
    fill: "none",
    stroke: "#3c4ef5",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1655",
    "data-name": "Line 1655",
    x2: 4.891,
    y2: 1.724,
    transform: "translate(534.281 268.021)",
    fill: "none",
    stroke: "#3c4ef5",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108908",
    "data-name": "Path 108908",
    d: "M.238.115,3.974,1.4",
    transform: "translate(534.281 271.021)",
    fill: "none",
    stroke: "#3c4ef5",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108907",
    "data-name": "Path 108907",
    d: "M0,0,1.818.643",
    transform: "translate(534.281 274.021)",
    fill: "none",
    stroke: "#3c4ef5",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_108904",
    "data-name": "Path 108904",
    d: "M2.085,21.568C24.968,8.842,37.986,10.1,43.612,13.479c5.722,3.435,4.546,8.906,1.064,12.149a76.563,76.563,0,0,1-6.24,5.582S17.07,45.368,5.243,47.148s-18.116-.677-20.972-5.534,3.069-11.8,17.813-20.045",
    transform: "translate(499.326 249.283)",
    stroke: "#1228f3",
    strokeWidth: 0.5,
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_62311",
    "data-name": "Group 62311"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_62310",
    "data-name": "Group 62310"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_108909",
    "data-name": "Path 108909",
    d: "M36.392,73.468c.749.323,2.848,1.249,1.316,1.871A3.874,3.874,0,0,1,34.383,74.3c-.229-1.192.4-1.437.4-1.437Z",
    transform: "translate(439.133 208.27)",
    fill: "#c2c7fb",
    stroke: "#707070",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108910",
    "data-name": "Path 108910",
    d: "M36.392,73.468c.749.323,2.848,1.249,1.316,1.871A3.874,3.874,0,0,1,34.383,74.3c-.229-1.192.4-1.437.4-1.437Z",
    transform: "translate(439.133 208.27)",
    fill: "none",
    stroke: "#1228f3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108911",
    "data-name": "Path 108911",
    d: "M40.092,72.381c-.061.286.353.357.623.492.5.25-.487.906-1.328.41s-.914-.648-.84-1.359,1.545.457,1.545.457",
    transform: "translate(435.375 209.115)",
    fill: "#ffd9bf",
    stroke: "#707070",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108912",
    "data-name": "Path 108912",
    d: "M40.092,72.381c-.061.286.353.357.623.492.5.25-.487.906-1.328.41s-.914-.648-.84-1.359S40.092,72.381,40.092,72.381Z",
    transform: "translate(435.375 209.115)",
    fill: "none",
    stroke: "#1228f3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108913",
    "data-name": "Path 108913",
    d: "M43.906,74.424c.662.431,2.491,2.077.89,2.487-.908.232-2.872-1.45-2.95-1.853a1.123,1.123,0,0,1,.7-1.437Z",
    transform: "translate(429.877 207.723)",
    fill: "#c2c7fb",
    stroke: "#707070",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108914",
    "data-name": "Path 108914",
    d: "M43.906,74.424c.662.431,2.491,2.077.89,2.487-.908.232-2.872-1.45-2.95-1.853a1.123,1.123,0,0,1,.7-1.437Z",
    transform: "translate(429.877 207.723)",
    fill: "none",
    stroke: "#1228f3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108915",
    "data-name": "Path 108915",
    d: "M47.005,73.293c-.061.286.339.619.568.851.362.367-.313.932-1.153.437s-.914-.648-.84-1.359,1.424.071,1.424.071",
    transform: "translate(426.598 208.227)",
    fill: "#ffd9bf",
    stroke: "#707070",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108916",
    "data-name": "Path 108916",
    d: "M47.005,73.293c-.061.286.339.619.568.851.362.367-.313.932-1.153.437s-.914-.648-.84-1.359S47.005,73.293,47.005,73.293Z",
    transform: "translate(426.598 208.227)",
    fill: "none",
    stroke: "#1228f3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108917",
    "data-name": "Path 108917",
    d: "M40.243,39.871c-.034.876-.163,6.135-.163,6.679,0,.52,2.179,1.41,2.179.253A70.3,70.3,0,0,0,42,37",
    transform: "translate(433.473 234.18)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108918",
    "data-name": "Path 108918",
    d: "M40.243,39.871c-.034.876-.163,6.135-.163,6.679,0,.52,2.179,1.41,2.179.253A70.3,70.3,0,0,0,42,37",
    transform: "translate(433.473 234.18)",
    fill: "none",
    stroke: "#1228f3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108919",
    "data-name": "Path 108919",
    d: "M47.572,27.443c-1.813.874-.812,7.437-.812,12.117,0,1.231,2.17,1.246,2.133.313-.043-1.119-.019-7.729-.021-8.117",
    transform: "translate(425.121 241.085)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108920",
    "data-name": "Path 108920",
    d: "M47.572,27.443c-1.813.874-.812,7.437-.812,12.117,0,1.231,2.17,1.246,2.133.313-.043-1.119-.019-7.729-.021-8.117",
    transform: "translate(425.121 241.085)",
    fill: "none",
    stroke: "#1228f3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108921",
    "data-name": "Path 108921",
    d: "M1.121,46.726c0,1.353,1.879,2.449,4.2,2.449s4.2-1.1,4.2-2.449-1.878-2.449-4.2-2.449-4.2,1.1-4.2,2.449",
    transform: "translate(477.092 228.923)",
    fill: "#fecf45",
    stroke: "#707070",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2102",
    "data-name": "Ellipse 2102",
    cx: 4.196,
    cy: 2.449,
    rx: 4.196,
    ry: 2.449,
    transform: "translate(478.213 273.2)",
    fill: "none",
    stroke: "#1228f3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108922",
    "data-name": "Path 108922",
    d: "M28.509,17.392c1.378.24,2.524.92,2.655,1.427s.346,1.743-.49,2.116c-1.842.823-2.64.226-4.27,1.856-1.357-.145-2.733-2.394-2.781-2.652s2.039-3.264,4.887-2.746",
    transform: "translate(449.071 248.39)",
    fill: "#02efc5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108923",
    "data-name": "Path 108923",
    d: "M28.509,17.392a4.2,4.2,0,0,1,2.784,1.515c.226.517.183,1.9-.653,2.27C28.8,22,28.034,21.161,26.4,22.791c-1.357-.145-2.733-2.394-2.781-2.652s2.039-3.264,4.887-2.746",
    transform: "translate(449.071 248.39)",
    fill: "none",
    stroke: "#1228f3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108924",
    "data-name": "Path 108924",
    d: "M15.768,23.568a9.373,9.373,0,0,0,2.6,5.083c.345.531-.709,1.358-1.274,1.041-.346-.193-2.64-2.108-2.833-3.91a2.033,2.033,0,0,0,.567-.23",
    transform: "translate(464.521 243.885)",
    fill: "#02efc5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108925",
    "data-name": "Path 108925",
    d: "M15.768,23.568a9.373,9.373,0,0,0,2.6,5.083c.345.531-.709,1.358-1.274,1.041-.346-.193-2.64-2.108-2.833-3.91a2.033,2.033,0,0,0,.567-.23",
    transform: "translate(464.521 243.885)",
    fill: "none",
    stroke: "#1228f3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108926",
    "data-name": "Path 108926",
    d: "M.982,41.745a4.2,4.2,0,1,0,4.2-4.2,4.2,4.2,0,0,0-4.2,4.2",
    transform: "translate(477.27 233.784)",
    fill: "#fef500",
    stroke: "#707070",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2103",
    "data-name": "Ellipse 2103",
    cx: 4.196,
    cy: 4.196,
    rx: 4.196,
    ry: 4.196,
    transform: "translate(478.252 271.333)",
    fill: "none",
    stroke: "#1228f3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108927",
    "data-name": "Path 108927",
    d: "M2.474,46.259C1.094,47.422,1.419,48.6,3.2,48.9a8.043,8.043,0,0,0,5.722-1.573c1.38-1.163,1.055-2.346-.726-2.641a8.043,8.043,0,0,0-5.722,1.573",
    transform: "translate(476.69 228.676)",
    fill: "#fdce45",
    stroke: "#707070",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108928",
    "data-name": "Path 108928",
    d: "M2.474,46.259C1.094,47.422,1.419,48.6,3.2,48.9a8.043,8.043,0,0,0,5.722-1.573c1.38-1.163,1.055-2.346-.726-2.641A8.043,8.043,0,0,0,2.474,46.259Z",
    transform: "translate(476.69 228.676)",
    fill: "none",
    stroke: "#1228f3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108929",
    "data-name": "Path 108929",
    d: "M24,48.371s.25.358.356.477c.177.2.124.865.578,1.233,1.2,1.09,1.774,1.16,2.084.642s-.219-.91-.525-1.129l-.39-.27h0c-.3-.211-.106-.6.387-.243.3.22.523-.072.316-.266a1.692,1.692,0,0,0-1.3-.677.99.99,0,0,1-.757-.476Z",
    transform: "translate(453.148 226.479)",
    fill: "#ffd9bf",
    stroke: "#707070",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108930",
    "data-name": "Path 108930",
    d: "M24,48.371s.25.358.356.477c.177.2.124.865.578,1.233,1.2,1.09,1.774,1.16,2.084.642s-.219-.91-.525-1.129l-.39-.27h0c-.3-.211-.106-.6.387-.243.3.22.523-.072.316-.266a1.692,1.692,0,0,0-1.3-.677.99.99,0,0,1-.757-.476Z",
    transform: "translate(453.148 226.479)",
    fill: "none",
    stroke: "#1228f3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108931",
    "data-name": "Path 108931",
    d: "M34.251,17.746c-2.052-.717-3.661.174-3.9,1.342-.614,3,.359,6.673,2.713,8.044.6.348,1.413-.574,1.13-1.063a13.7,13.7,0,0,1-1.8-3.268,5.884,5.884,0,0,1,.411-3.271",
    transform: "translate(444.292 248.276)",
    fill: "#02efc5",
    stroke: "#707070",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108932",
    "data-name": "Path 108932",
    d: "M34.251,17.746c-2.052-.717-3.661.174-3.9,1.342-.614,3,.359,6.673,2.713,8.044.6.348,1.413-.574,1.13-1.063a13.7,13.7,0,0,1-1.8-3.268,5.884,5.884,0,0,1,.411-3.271",
    transform: "translate(444.292 248.276)",
    fill: "none",
    stroke: "#1228f3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108933",
    "data-name": "Path 108933",
    d: "M25.689,18.4a.954.954,0,0,0,1.292,1.374A.954.954,0,0,0,25.689,18.4",
    transform: "translate(452.642 247.758)",
    fill: "#ffd9bf",
    stroke: "#707070",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108934",
    "data-name": "Path 108934",
    d: "M25.689,18.4a.954.954,0,0,0,1.292,1.374A.954.954,0,0,0,25.689,18.4Z",
    transform: "translate(452.642 247.758)",
    fill: "none",
    stroke: "#1228f3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108935",
    "data-name": "Path 108935",
    d: "M13.845,8.034a2.3,2.3,0,1,1-.1,3.244,2.295,2.295,0,0,1,.1-3.244",
    transform: "translate(465.562 255.557)",
    fill: "#ffd9bf",
    stroke: "#707070",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108936",
    "data-name": "Path 108936",
    d: "M13.845,8.034a2.3,2.3,0,1,1-.1,3.244A2.295,2.295,0,0,1,13.845,8.034Z",
    transform: "translate(465.562 255.557)",
    fill: "none",
    stroke: "#1228f3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108937",
    "data-name": "Path 108937",
    d: "M9.164,5.461a1.243,1.243,0,0,1,1.167.442,1.8,1.8,0,0,0-.5-1.622,1.424,1.424,0,0,1,.995.073,1.16,1.16,0,0,0-.908-.973,3.274,3.274,0,0,1,1.713-.116c-.555-1.458-2.961-1.8-3.672-1.536A3.138,3.138,0,0,1,8.422.981a1.541,1.541,0,0,0-1.473.8A1.67,1.67,0,0,0,6.278.75c-.072.773-.81,1.238-1.2,1.741-.71.908-.664,1.516-.493,1.768.235.3.876-.284,1.093-.292A5.379,5.379,0,0,1,6.7,3.915a3.13,3.13,0,0,1,1.459.519A3.314,3.314,0,0,1,9.164,5.461",
    transform: "translate(474.039 260.37)",
    fill: "#3c4ef5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108938",
    "data-name": "Path 108938",
    d: "M9.164,5.461a1.243,1.243,0,0,1,1.167.442,1.8,1.8,0,0,0-.5-1.622,1.424,1.424,0,0,1,.995.073,1.16,1.16,0,0,0-.908-.973,3.274,3.274,0,0,1,1.713-.116c-.555-1.458-2.961-1.8-3.672-1.536A3.138,3.138,0,0,1,8.422.981a1.541,1.541,0,0,0-1.473.8A1.67,1.67,0,0,0,6.278.75c-.072.773-.81,1.238-1.2,1.741-.71.908-.664,1.516-.493,1.768.235.3.876-.284,1.093-.292A5.379,5.379,0,0,1,6.7,3.915a3.13,3.13,0,0,1,1.459.519A3.314,3.314,0,0,1,9.164,5.461Z",
    transform: "translate(474.039 260.37)",
    fill: "none",
    stroke: "#1228f3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108939",
    "data-name": "Path 108939",
    d: "M27.152,11.008a.521.521,0,0,0-.14-.349.639.639,0,0,0-.924.869.538.538,0,0,0,.447.16",
    transform: "translate(452.563 253.328)",
    fill: "#ffd9bf",
    stroke: "#707070",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108940",
    "data-name": "Path 108940",
    d: "M27.152,11.008a.521.521,0,0,0-.14-.349.639.639,0,0,0-.924.869.538.538,0,0,0,.447.16",
    transform: "translate(452.563 253.328)",
    fill: "none",
    stroke: "#1228f3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108941",
    "data-name": "Path 108941",
    d: "M36.928,77.5a.855.855,0,0,0-.661.747",
    transform: "translate(439.923 204.92)",
    fill: "none",
    stroke: "#1228f3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108942",
    "data-name": "Path 108942",
    d: "M44.127,80.471a.842.842,0,0,0-.982.709",
    transform: "translate(430.815 202.783)",
    fill: "none",
    stroke: "#1228f3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_24196",
    "data-name": "Mask Group 24196",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_62313",
    "data-name": "Group 62313",
    transform: "translate(4 4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_108895-2",
    "data-name": "Path 108895",
    d: "M2.237,9.52c-.108-.246-.625-.361-1.153-.258S.214,9.649.323,9.9s.625.361,1.153.257.869-.387.761-.633",
    transform: "translate(542.97 247.76)",
    fill: "#1228f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108897-2",
    "data-name": "Path 108897",
    d: "M13.967,5.389c-.108-.246-.625-.361-1.153-.258s-.869.387-.761.633.625.361,1.153.257.869-.387.761-.633",
    transform: "translate(526.372 250.177)",
    fill: "#1228f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108902-2",
    "data-name": "Path 108902",
    d: "M7.771,7.258S8,4.579,6.1,5.091C3.778,5.718,2.9,8.429,2.9,8.429s-.474,1.693-.169,10v3.408",
    transform: "translate(536.485 250.216)",
    fill: "none",
    stroke: "#3c4ef5",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108903-2",
    "data-name": "Path 108903",
    d: "M19.521,3.178S19.729.486,17.838,1c-2.326.627-3.207,3.338-3.207,3.338s-.474,1.693-.169,10l.094,9.225",
    transform: "translate(519.868 252.611)",
    fill: "none",
    stroke: "#3c4ef5",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1652-2",
    "data-name": "Line 1652",
    x2: 4.773,
    y2: 1.802,
    transform: "translate(534.24 259.157)",
    fill: "none",
    stroke: "#3c4ef5",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1653-2",
    "data-name": "Line 1653",
    x1: 4.866,
    y1: 1.728,
    transform: "translate(534.23 262.124)",
    fill: "none",
    stroke: "#3c4ef5",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1654-2",
    "data-name": "Line 1654",
    x2: 4.891,
    y2: 1.724,
    transform: "translate(534.281 265.021)",
    fill: "none",
    stroke: "#3c4ef5",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1655-2",
    "data-name": "Line 1655",
    x2: 4.891,
    y2: 1.724,
    transform: "translate(534.281 268.021)",
    fill: "none",
    stroke: "#3c4ef5",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108908-2",
    "data-name": "Path 108908",
    d: "M.238.115,3.974,1.4",
    transform: "translate(534.281 271.021)",
    fill: "none",
    stroke: "#3c4ef5",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108907-2",
    "data-name": "Path 108907",
    d: "M0,0,1.818.643",
    transform: "translate(534.281 274.021)",
    fill: "none",
    stroke: "#3c4ef5",
    strokeWidth: 1
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.2d314a1119ba28b169d31c026fd374e7.svg";
export { ForwardRef as ReactComponent };